export default "__VITE_ASSET__3bf300a6__"